import { Link } from 'react-router-dom';
import { LogIn, UserPlus } from 'lucide-react';
import { Button } from '../ui/Button';
import { useAuth } from '../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import { isDashboardPath } from '../../lib/utils';

interface AuthButtonProps {
  className?: string;
}

export const LoginButton = ({ className = '' }: AuthButtonProps) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  
  // Don't show login button if user is authenticated or in dashboard
  if (isAuthenticated || isDashboardPath(location.pathname)) {
    return null;
  }
  
  return (
    <Link to="/auth/login">
      <Button
        variant="ghost"
        size="default"
        className={`font-medium hover:bg-primary/5 ${className}`}
      >
        <LogIn className="h-4 w-4 mr-2" />
        Sign In
      </Button>
    </Link>
  );
};

export const FreeTrialButton = ({ className = '' }: AuthButtonProps) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  
  // Don't show free trial button if user is authenticated or in dashboard
  if (isAuthenticated || isDashboardPath(location.pathname)) {
    return null;
  }
  
  return (
    <Link to="/auth/register">
      <Button
        variant="primary"
        size="default"
        className={`font-medium shadow-sm ${className}`}
      >
        <UserPlus className="h-4 w-4 mr-2" />
        Start Free Trial
      </Button>
    </Link>
  );
};